import { MapPin, CalendarDays } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { scrollTo } from "@/lib/lenis";

export default function Events({ events }) {
  return (
    <section id="events" className="py-28 lg:py-36 bg-royal-900/40 border-y border-gold/10" data-testid="events-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading
          eyebrow="Upcoming Events"
          title={<>The <span className="gold-text">Calendar</span> of Dreams</>}
          sub="Stages being set. Spotlights being warmed. Choose yours."
          testId="events-heading"
        />
        <div className="grid md:grid-cols-3 gap-6" data-testid="events-grid">
          {events.map((e, i) => {
            const open = e.status === "Registrations Open";
            return (
              <Reveal key={e.id} delay={0.1 * i}>
                <article
                  className={`group h-full glass-card rounded-md overflow-hidden flex flex-col transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/40 ${e.featured ? "ring-1 ring-gold/40" : ""}`}
                  data-testid={`event-card-${e.id}`}
                >
                  <div className="relative h-56 overflow-hidden">
                    <img
                      src={e.image}
                      alt={`${e.name} — ${e.city}`}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-[1100ms] group-hover:scale-105"
                    />
                    <span
                      className={`absolute top-4 left-4 rounded-full px-4 py-1.5 text-[11px] font-semibold tracking-widest uppercase ${open ? "bg-fuchsia text-white" : "bg-royal-950/80 text-gold border border-gold/40"}`}
                      data-testid={`event-status-${e.id}`}
                    >
                      {e.status}
                    </span>
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <h3 className="font-display text-2xl text-cream">{e.name}</h3>
                    <div className="mt-3 flex items-center gap-4 text-xs text-gold/90">
                      <span className="flex items-center gap-1.5"><MapPin size={13} /> {e.city}</span>
                      <span className="flex items-center gap-1.5"><CalendarDays size={13} /> {e.date}</span>
                    </div>
                    <p className="mt-3 text-sm text-muted leading-relaxed flex-1">{e.description}</p>
                    <button
                      onClick={() => open && scrollTo("#register")}
                      disabled={!open}
                      className={`mt-6 rounded-full px-6 py-2.5 text-xs font-semibold tracking-widest transition-all duration-300 ${open ? "bg-gold text-royal-950 hover:shadow-[0_0_25px_rgba(212,175,55,0.4)]" : "border border-gold/30 text-muted cursor-not-allowed"}`}
                      data-testid={`event-register-${e.id}`}
                    >
                      {open ? "REGISTER" : "COMING SOON"}
                    </button>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
